import React, { useEffect, useState } from 'react'
import { toast } from "react-toastify"
import axios from "axios"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import MessageBox from '../../../components/CommonComponents/MessageBox'
import { audioOrderDefaultURL } from '../../../components/CommonApis/CommonAudioOrderApi'
import Response_Processing from '../../../layout/Others/Response_Processing'
import { FaEllipsisVertical } from 'react-icons/fa6';
import NoRecordTable from '../../../components/CommonComponents/NoRecordTable';
import { Link } from 'react-router-dom';
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton';
import { getItemToken } from '../../../Utils/localStorageUtils';
import AdminSaveHeader from '../../../components/CommonComponents/AdminSaveHeader';
import AdminSwitch from '../../../components/CommonComponents/AdminSwitch';
import { IconEditFigma } from '../../../Assets/MyIcons';
import MessageHeading from '../../../components/CommonComponents/MessageHeading';
import MessageLabel from '../../../components/CommonComponents/MessageLabel';

const AudioSettings = () => {
    const [apiData, setApiData] = useState([]);
    const [enableSetting, setEnableSetting] = useState([])
    const [editSetting, setEditSetting] = useState(null)
    const [showOverlay, setShowOverlay] = useState(false);
    const [loading, setLoading] = useState(false)
    const [withOutRefresh, setWithOutRefresh] = useState(false)

    const HeaderToken = getItemToken('access_token')

    const fetData = async () => {
        try {
            setLoading(true)
            const response = await axios.get(`${audioOrderDefaultURL?.listApi}`, { headers: HeaderToken })
            const result = response?.data?.Web_Audio_HomePage_Order;
            if (response?.data?.status) {
                setApiData(result)
                setLoading(false)
            }
            else {
                setLoading(false)
            }

        }
        catch (error) {
            const errMessage = error?.response?.data?.message
            console.error(errMessage)
        }
    }

    const enableData = async () => {
        try {
            setLoading(true)
            const response = await axios.get(`${audioOrderDefaultURL?.enableSettingURL}`, { headers: HeaderToken })
            const result = response?.data
            if (response?.data?.status) {
                setEnableSetting(result?.Web_Audio_HomePage_Order)
                setLoading(false)
            }
            else {
                setLoading(false)
            }

        }
        catch (error) {
            const errMessage = error?.response?.data?.message
            console.error(errMessage)
        }
    }

    const handleDragEnd = (result) => {
        if (!result.destination) return;
        const reorderedItems = Array?.from(apiData);
        const [movedItem] = reorderedItems?.splice(result?.source?.index, 1);
        reorderedItems.splice(result?.destination?.index, 0, movedItem);
        setApiData(reorderedItems);
        saveShuffleOrder(reorderedItems);
    };

    const saveShuffleOrder = async (updatedItems) => {
        setShowOverlay(true);
        if (!updatedItems || updatedItems?.length == 0) {
            console.error("Menu items are empty");
            return;
        }
        const positions = updatedItems?.map((menuItem) => menuItem?.id);
        const ids = updatedItems?.map((_, index) => index + 1);

        const requestData = {
            id: positions,
            position: ids,
        };

        try {
            const response = await axios.post(`${audioOrderDefaultURL?.orderApi}`, requestData, { headers: HeaderToken });
            const result = response.data;
            if (result?.status) {
                toast.success(result?.message);
                setShowOverlay(false);
                setWithOutRefresh(!withOutRefresh)
            }
            else {
                toast.error(result?.message);
                setShowOverlay(false);
            }
        } catch (err) {
            var errorMessage = err?.response?.data?.message;
            toast.error(errorMessage);
            setShowOverlay(false);
        }
    };

    const handleToggleSettings = async (name, value) => {
        const updatedEditSettings = enableSetting.map(item => ({
            [item.name]: item.name === name ? (value ? 0 : 1) : item?.Web_HomePage_status,
            'audio_home_settings': item.name === name ? (value ? 0 : 1) : item?.Web_HomePage_status,
        }));
        const updatedSetting = enableSetting.map((item) => item?.name === name ? { ...item, Web_HomePage_status: value ? 0 : 1 } : item);
        setEnableSetting(updatedSetting)
    }

    const updateSetting = async () => {
        setShowOverlay(true)
        try {
            const formData = new URLSearchParams();
            enableSetting.forEach((item) => {
                const status = Number.isNaN(parseInt(item?.Web_HomePage_status, 10)) ? 0 : parseInt(item?.Web_HomePage_status, 10);
                formData.append(item?.name, status);
            });
            const response = await axios.post(`${audioOrderDefaultURL?.updateSettingURL}`, formData, {
                headers: {
                    ...HeaderToken,
                    'Content-Type': 'application/x-www-form-urlencoded' // Specify the content type
                }
            });
            const result = response.data;
            if (result?.status) {
                toast.success(result?.message);
                setShowOverlay(false);
                setWithOutRefresh(!withOutRefresh)
            }
            else {
                toast.error(result?.message);
                setShowOverlay(false);
            }
        } catch (err) {
            var errorMessage = err?.response?.data?.message;
            toast.error(errorMessage);
            setShowOverlay(false);
        }
    }
    useEffect(() => {
        fetData()
        enableData()
    }, [withOutRefresh])
    return (
        <div className='px-2 px-md-0'>

            {showOverlay && (<Response_Processing />)}
            <div className={`col-sm-8 col-12`}>
                <MessageHeading text={"Audio Page Menu Settings"} className="admin-title pb-sm-0  text-md-start" noMargin />
            </div>
            <div className="row align-items-center theme-bg-color rounded-2 p-3">
                {enableSetting?.map((item) => {
                    return <div className={`col-12 col-md-6 category-order-title p-1 mb-2`}>
                        <div className="input-group color-picker d-flex align-items-center justify-content-between">
                            <div className="col-6 col-md-6">
                                <MessageLabel text={item?.header_name} classname="theme-text-color" noMargin />
                            </div>
                            <div className="col-6 col-md-6 text-end px-2">
                                <AdminSwitch name={item?.name} checked={item?.Web_HomePage_status} onChange={() => handleToggleSettings(item?.name, item?.Web_HomePage_status)} />
                            </div>
                        </div>
                    </div>
                })}
                <div className='col-12 text-end'>
                    <AdminCustomButton saveMethod={updateSetting} saveText="Save Setting" />
                </div>
            </div>
            <h4 className="admin-title mb-4 theme-text-color text-md-start">
                <MessageBox text="Order Audio Page" classname="theme-text-color" />
            </h4>
            <div className="bootstrapTable theme-bg-color p-3 rounded-2">
                <div className="">
                    <div className="row m-0 theme-border-bottom-secondary pb-3">
                        <div className="col-2 "> <label className="theme-text-color fw-bold fs-6"># </label> </div>
                        <div className="col-5 "><label className="theme-text-color fw-bold fs-6">Name</label></div>
                        <div className="col-5 "><label className="theme-text-color fw-bold fs-6"> Actions </label> </div>
                    </div>
                    <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="menu-items" className="theme-bg-color"   >
                            {(provided) => (
                                <ul  {...provided.droppableProps} ref={provided.innerRef} className="pb-5 px-0 theme-bg-color list-unstyled m-0 p-0">
                                    {loading ? <NoRecordTable result={apiData?.length} loader={true} /> :
                                        apiData?.map((item, index) => (
                                            <Draggable key={item?.id.toString()} draggableId={item?.id.toString()} index={index} >
                                                {(provided) => (
                                                    <li ref={provided.innerRef} {...provided.draggableProps}  {...provided.dragHandleProps} className={` theme-bg-color theme-text-color  orderborder ${item.order} index ${index + 1} w-100 theme-border-bottom-secondary`} >
                                                        <div className="row m-0 p-0 align-items-center">
                                                            <div className="col-2">
                                                                <div className='d-flex position-relative '>
                                                                    <p className="theme-text-color mb-3 admin-input-title d-block position-relative"> {item?.order_id} </p>
                                                                </div >
                                                            </div>
                                                            <div className="col-5  category-order-title">
                                                                <MessageLabel text={item?.header_name} classname="theme-text-color" noMargin />
                                                            </div>
                                                            <div className="col-5  category-order-title">
                                                                <div className="editdropdown">
                                                                    <span className="editdropdown-button">
                                                                        <span>
                                                                            <FaEllipsisVertical className="theme-text-color" />
                                                                        </span>
                                                                    </span>
                                                                    <div className="editdropdown-menu theme-bg-color">
                                                                        <Link to={`/edit-audio-order/${item?.id}`} className="theme-text-color  theme-bg-color">
                                                                            <span>
                                                                                <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                                                                                <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
                                                                            </span>
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )}
                                            </Draggable>
                                        ))}
                                </ul>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>
            </div>
        </div>

    )
}

export default AudioSettings